import axios from 'axios'
import querystring from 'querystring'
import {  browserHistory } from 'react-router'
import {  push } from "react-router-redux"
import * as config from "../config"

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_ERROR = "USER_LOGIN_ERROR";

export const USER_LOGOUT = "USER_LOGOUT";

export const USER_PROFILE_CHANGE = "USER_PROFILE_CHANGE";

export const USER_INIT = "USER_INIT";
export const USER_SET = "USER_SET";


export function ProfileInit() {
    return (dispatch) => {

        dispatch({
            type: USER_INIT
        });

    }
}

export function ProfileGetInfo() {
    return(dispatch) => {
        axios.get(
            "/api/Account/UserInfo",
        )
            .then(function (response) {
                console.log("response", response);

                dispatch({
                    type: USER_SET,
                    payload:response.data
                });

            })
    }
}

export function ProfileChange(name, value) {
    return (dispatch) => {
        dispatch({
            type: USER_PROFILE_CHANGE,
            payload: {
                name: name,
                value: value
            }
        });
    }
}

export function ProfileLogin(email,password) {
    return (dispatch) => {
        dispatch({
            type: USER_LOGIN_REQUEST,
            payload:{}
        });

        axios.post(
            config.apiUrl+"/Token",
            querystring.stringify({
                UserName: email,
                Password: password,
                grant_type: "password"
            }),
            {
                headers: {
                    "content-type": "application/x-www-form-urlencoded",
                }
            }
        )
            .then(function (response) {
                console.log("response", response);

                dispatch({
                    type: USER_LOGIN_SUCCESS,
                    payload: response.data
                });

            })
            .catch(function (error) {
                console.log("error", error);
                console.log("response", error.response);
                let errorMessage = error.response?  error.response.data.error_description : "Внутреняя ошибка"
                dispatch({
                    type: USER_LOGIN_ERROR,
                    payload: errorMessage
                });
            });
    }
}

export function ProfileLogout(backUrl) {
    return (dispatch) => {
        dispatch({
            type: USER_LOGOUT,
            payload: { backUrl }
        });

        dispatch(push("/auth"));
    }
}

export function ProfileGoAuth(backUrl) {
    return (dispatch) => {
        if (backUrl == "/auth") backUrl = null;

        dispatch({
            type: USER_PROFILE_CHANGE,
            payload:{
                   name:"backUrl",
                    value:backUrl
            }
        });

        dispatch(push("/auth"));
    }
}

export function ProfileGetRole(){
    return(dispatch) =>{

        axios.get(
            config.apiUrl + "/userrole"
        )
        .then((response)=>{
            console.log(response.data);
            dispatch({
                type: USER_PROFILE_CHANGE,
                payload:{
                    name:"roles",
                    value:response.data.content
                }
            });
        })

    }
}




// WEBPACK FOOTER //
// ./src/actions/profileActions.js